
import { defineComponent } from 'vue';
import BarraLateral from './components/BarraLateral.vue';
import Notificacoes from './components/Notificacoes.vue'

export default defineComponent({
    name: "App",
    components: {
      BarraLateral,
      Notificacoes,
      
     },
     data () {
      return {
        modoEscuroAtivo : false
      }
     },
     methods: {
      
      trocarTema(modoEscuroAtivo: boolean){
        this.modoEscuroAtivo = modoEscuroAtivo
      }
     }
});
